
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ce22300c&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SellersSettings.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SellersSettings.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ce22300c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SellersSettings.vue"),
  /* scopeId */
  "data-v-ce22300c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/settings/SellersSettings.vue
// module id = 307
// module chunks = 2